<template>
    <v-btn
    class="mx-1 mr-5"
      @click="goBack"
      outlined
      color="primary"

    >
      
      <v-icon
        left
        dark
      >
        mdi-arrow-left-circle

      </v-icon>
      Voltar
    </v-btn>


</template>

<script>
export default {
  methods: {
    goBack() {
      return this.$router.go(-1);
    }
  }
};
</script>
